module.exports = __webpack_public_path__ + "img/blank-screen.98d4ba43.png";